import { Document, DOCUMENT_STATUS, DOCUMENT_UPLOAD_PROGRESS } from '../types/session';
import { FileType } from './formUtils';

export const getDocumentUploadProgress = (documents: Document[]): string | null => {
  // IF every document.documentStatus => metadataCreated => Case M039
  const isAllMetadataCreated = documents.every((doc) => doc.documentStatus === DOCUMENT_STATUS.metaDataCreated);
  if (isAllMetadataCreated) {
    return DOCUMENT_UPLOAD_PROGRESS.metaDataCreated;
  }

  // IF document.documentStatus of every documents is uploadCompleted OR urlGenerated OR smsSent => Case M039
  const isAllUploadedOrRequested = documents.every(
    (doc) =>
      doc.documentStatus === DOCUMENT_STATUS.uploadCompleted ||
      doc.documentStatus === DOCUMENT_STATUS.urlGenerated ||
      doc.documentStatus === DOCUMENT_STATUS.smsSent,
  );
  if (isAllUploadedOrRequested) {
    return DOCUMENT_UPLOAD_PROGRESS.completed;
  }

  // If any document has at least one document.documentStatus as DOCUMENT_STATUS.uploadFailed => Case M040
  const isAnyUploadFailed = documents.some((doc) => doc.documentStatus === DOCUMENT_STATUS.uploadFailed);
  if (isAnyUploadFailed) {
    return DOCUMENT_UPLOAD_PROGRESS.inProgress;
  }

  // IF at least one document has document.documentStatus as metadataCreated AND other has uploadCompleted OR urlGenerated OR smsSent => Case M040
  const isMixedMetadataAndUploadedOrRequested =
    documents.some((doc) => doc.documentStatus === DOCUMENT_STATUS.metaDataCreated) &&
    documents.some(
      (doc) =>
        doc.documentStatus === DOCUMENT_STATUS.uploadCompleted ||
        doc.documentStatus === DOCUMENT_STATUS.urlGenerated ||
        doc.documentStatus === DOCUMENT_STATUS.smsSent,
    );
  if (isMixedMetadataAndUploadedOrRequested) {
    return DOCUMENT_UPLOAD_PROGRESS.inProgress;
  }

  // Add a default return value if no conditions are met.
  return null;
};

export const getFileName = (file: FileType) => {
  if (file.content) return file.content.name;
  return undefined;
};
